module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-husk-297d871d5d644358546a5bb534d70309.svg";